module.exports = __webpack_public_path__ + "static/img/banner.518cc3d2.png";